
import { buildAssetUri } from '@/utils/mixins';
import Avatar from 'vue-avatar';

export default {
  // TODO: this component can be used outside leagues (PendingOrdersDisplayCard).
  // Either rename it to something more general, or split off a dedicated component for non-league usages.
  name: 'UILeagueTopAvatars',
  components: { Avatar },
  mixins: [buildAssetUri],
  props: {
    topAvatars: {
      type: Array,
      required: true,
    },
    playerCount: {
      type: Number,
      required: true,
    },
    maxAvatarsDisplayed: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    visibleAvatars() {
      return this.topAvatars.slice(0, this.maxAvatarsDisplayed);
    },
    playerCountString() {
      return this.playerCount == 0
        ? '0'
        : '+' + (this.playerCount - this.visibleAvatars.length);
    },
  },
};
